const v = "5.5.7";
const meta = {
	g: "LottieFiles AE 0.1.21",
	a: "SCDesign Eddy",
	k: "",
	d: "SCB Success Tick",
	tc: "Dark Theme"
};
const fr = 60;
const ip = 1;
const op = 263;
const w = 1125;
const h = 1125;
const nm = "3.20.7 copy";
const ddd = 0;
const assets = [
];
const layers = [
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "Tick",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0
							],
							y: [
								1.002
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 10,
						s: [
							360
						]
					},
					{
						t: 50,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					563.5,
					568,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					154.5,
					122,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-114.196,
										19.689
									],
									[
										-57.57,
										81.568
									],
									[
										114.196,
										-81.568
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.219607844949,
								0.823529422283,
								0,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 40,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								154.196,
								121.568
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 20,
							s: [
								0
							]
						},
						{
							t: 80,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "Circle Border",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 30,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					562.5,
					562.5,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					263,
					263,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0,
								0,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 10,
						s: [
							0,
							0,
							100
						]
					},
					{
						t: 60,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										132.335,
										0
									],
									[
										0,
										-132.336
									],
									[
										-132.336,
										0
									],
									[
										0,
										132.335
									]
								],
								o: [
									[
										-132.336,
										0
									],
									[
										0,
										132.335
									],
									[
										132.335,
										0
									],
									[
										0,
										-132.336
									]
								],
								v: [
									[
										0,
										-240.001
									],
									[
										-240,
										-1e-3
									],
									[
										0,
										240
									],
									[
										240,
										-1e-3
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 1,
						ty: "sh",
						ix: 2,
						ks: {
							a: 0,
							k: {
								i: [
									[
										144.743,
										0
									],
									[
										0,
										144.743
									],
									[
										-144.743,
										0
									],
									[
										0,
										-144.743
									]
								],
								o: [
									[
										-144.743,
										0
									],
									[
										0,
										-144.743
									],
									[
										144.743,
										0
									],
									[
										0,
										144.743
									]
								],
								v: [
									[
										0,
										262.5
									],
									[
										-262.5,
										-1e-3
									],
									[
										0,
										-262.501
									],
									[
										262.5,
										-1e-3
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 2",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "mm",
						mm: 1,
						nm: "Merge Paths 1",
						mn: "ADBE Vector Filter - Merge",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.219607844949,
								0.823529422283,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								262.75,
								262.75
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 4,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "Main Circle",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					562.5,
					562.5,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					263,
					263,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0,
								0,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 0,
						s: [
							0,
							0,
							100
						]
					},
					{
						t: 60,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-144.975,
										0
									],
									[
										0,
										-144.975
									],
									[
										144.975,
										0
									],
									[
										0,
										144.975
									]
								],
								o: [
									[
										144.975,
										0
									],
									[
										0,
										144.975
									],
									[
										-144.975,
										0
									],
									[
										0,
										-144.975
									]
								],
								v: [
									[
										0,
										-262.5
									],
									[
										262.5,
										0
									],
									[
										0,
										262.5
									],
									[
										-262.5,
										0
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.015686275437,
								0.450980395079,
								0.917647063732,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								262.75,
								262.75
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "Wave Right",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.017
							],
							y: [
								0.881
							]
						},
						o: {
							x: [
								0.35
							],
							y: [
								0
							]
						},
						t: 0,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.656
							],
							y: [
								1.005
							]
						},
						o: {
							x: [
								0.323
							],
							y: [
								-6e-3
							]
						},
						t: 121,
						s: [
							20
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 130,
						s: [
							10
						]
					},
					{
						t: 160,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 0,
						s: [
							-360
						]
					},
					{
						t: 130,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					563.196,
					567.568,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-111.219,
					170.701,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0,
								0,
								0.667
							],
							y: [
								0.988,
								0.988,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 10,
						s: [
							0,
							0,
							100
						]
					},
					{
						t: 80,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										3.946,
										-112.994
									],
									[
										165.148,
										-49.715
									],
									[
										0,
										0
									],
									[
										4.252,
										0.688
									]
								],
								o: [
									[
										-2.63,
										75.329
									],
									[
										0,
										0
									],
									[
										28.678,
										-112.95
									],
									[
										-6.379,
										-1.033
									]
								],
								v: [
									[
										123.861,
										8.603
									],
									[
										-127.807,
										196.169
									],
									[
										-118.74,
										-24.679
									],
									[
										-82.102,
										-195.136
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.015686275437,
								0.450980395079,
								0.917647063732,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								128.057,
								196.419
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "Wave Left",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.017
							],
							y: [
								0.881
							]
						},
						o: {
							x: [
								0.35
							],
							y: [
								0
							]
						},
						t: 0,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.656
							],
							y: [
								1.005
							]
						},
						o: {
							x: [
								0.323
							],
							y: [
								-6e-3
							]
						},
						t: 121,
						s: [
							20
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 130,
						s: [
							10
						]
					},
					{
						t: 160,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0
							],
							y: [
								0.988
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 0,
						s: [
							-180
						]
					},
					{
						t: 130,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					563.196,
					567.568,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					395.996,
					144.882,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0,
								0,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 10,
						s: [
							0,
							0,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 80,
						s: [
							100,
							100,
							100
						]
					},
					{
						t: 130,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										25.434,
										110.165
									],
									[
										-182.472,
										64.767
									],
									[
										0,
										0
									],
									[
										-4.286,
										0.435
									]
								],
								o: [
									[
										-16.956,
										-73.443
									],
									[
										0,
										0
									],
									[
										1.533,
										116.524
									],
									[
										6.428,
										-0.653
									]
								],
								v: [
									[
										-120.574,
										31.694
									],
									[
										127.701,
										-175.62
									],
									[
										122.375,
										1.052
									],
									[
										131.102,
										175.185
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.015686275437,
								0.450980395079,
								0.917647063732,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								137.78,
								175.87
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "Wave Bottom",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0
							],
							y: [
								0.8
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 0,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.684
							],
							y: [
								1.003
							]
						},
						o: {
							x: [
								0.351
							],
							y: [
								0
							]
						},
						t: 120,
						s: [
							20
						]
					},
					{
						i: {
							x: [
								0.001
							],
							y: [
								1.043
							]
						},
						o: {
							x: [
								0.299
							],
							y: [
								0.035
							]
						},
						t: 121,
						s: [
							30
						]
					},
					{
						t: 160,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 0,
						s: [
							-260
						]
					},
					{
						t: 130,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					562.5,
					562.5,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					165.5,
					-20.5,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0,
								0,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 10,
						s: [
							0,
							0,
							100
						]
					},
					{
						t: 80,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										-40,
										-12.5
									],
									[
										-54.535,
										83.044
									],
									[
										9.683,
										112.222
									]
								],
								o: [
									[
										77.5,
										77.5
									],
									[
										60,
										18.75
									],
									[
										36.357,
										-55.361
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-217.073,
										9.678
									],
									[
										-40.823,
										144.678
									],
									[
										167.381,
										84.166
									],
									[
										207.39,
										-167.209
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.015686275437,
								0.450980395079,
								0.917647063732,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								217.323,
								167.46
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "Wave Top",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 0,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.684
							],
							y: [
								1.003
							]
						},
						o: {
							x: [
								0.351
							],
							y: [
								0
							]
						},
						t: 120,
						s: [
							20
						]
					},
					{
						i: {
							x: [
								0.001
							],
							y: [
								0.978
							]
						},
						o: {
							x: [
								0.299
							],
							y: [
								0.032
							]
						},
						t: 121,
						s: [
							30
						]
					},
					{
						t: 160,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 0,
						s: [
							-260
						]
					},
					{
						t: 130,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					563.196,
					567.568,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					335.196,
					407.068,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0,
								0,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 10,
						s: [
							0,
							0,
							100
						]
					},
					{
						t: 80,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										-82.5,
										65
									],
									[
										-30,
										-37.5
									],
									[
										112.221,
										-59.458
									]
								],
								o: [
									[
										-94.408,
										-203.576
									],
									[
										123.75,
										-97.5
									],
									[
										20,
										25
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-130.889,
										250.182
									],
									[
										-148.75,
										-152.682
									],
									[
										211.25,
										-70.182
									],
									[
										72.918,
										56.505
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.015686275437,
								0.450980395079,
								0.917647063732,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								231.5,
								250.432
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "Top Dot",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.142
							],
							y: [
								16.615
							]
						},
						o: {
							x: [
								0.453
							],
							y: [
								0
							]
						},
						t: 90,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0.587
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.26
							],
							y: [
								0.042
							]
						},
						t: 121,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 140,
						s: [
							30
						]
					},
					{
						t: 170,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 80,
						s: [
							267.168,
							302.194,
							0
						],
						to: [
							-12.028,
							-12.886,
							0
						],
						ti: [
							12.028,
							12.886,
							0
						]
					},
					{
						t: 140,
						s: [
							195,
							224.875,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					19,
					19,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0,
								0,
								0.667
							],
							y: [
								0.997,
								0.997,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 80,
						s: [
							0,
							0,
							100
						]
					},
					{
						t: 100,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-10.355,
										0
									],
									[
										0,
										-10.355
									],
									[
										10.355,
										0
									],
									[
										0,
										10.355
									]
								],
								o: [
									[
										10.355,
										0
									],
									[
										0,
										10.355
									],
									[
										-10.355,
										0
									],
									[
										0,
										-10.355
									]
								],
								v: [
									[
										0,
										-18.75
									],
									[
										18.75,
										0
									],
									[
										0,
										18.75
									],
									[
										-18.75,
										0
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.015686275437,
								0.450980395079,
								0.917647063732,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								19,
								19
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 17,
		ty: 4,
		nm: "Bottom Dot",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.142
							],
							y: [
								12.467
							]
						},
						o: {
							x: [
								0.453
							],
							y: [
								0
							]
						},
						t: 90,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0.587
							],
							y: [
								0.997
							]
						},
						o: {
							x: [
								0.26
							],
							y: [
								0.043
							]
						},
						t: 121,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 140,
						s: [
							50
						]
					},
					{
						t: 170,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 80,
						s: [
							792.636,
							849.867,
							0
						],
						to: [
							10.311,
							13.772,
							0
						],
						ti: [
							-10.311,
							-13.772,
							0
						]
					},
					{
						t: 140,
						s: [
							854.5,
							932.5,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					19,
					19,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0,
								0,
								0.667
							],
							y: [
								0.997,
								0.997,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 80,
						s: [
							0,
							0,
							100
						]
					},
					{
						t: 100,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-10.355,
										0
									],
									[
										0,
										-10.355
									],
									[
										10.355,
										0
									],
									[
										0,
										10.355
									]
								],
								o: [
									[
										10.355,
										0
									],
									[
										0,
										10.355
									],
									[
										-10.355,
										0
									],
									[
										0,
										-10.355
									]
								],
								v: [
									[
										0,
										-18.75
									],
									[
										18.75,
										0
									],
									[
										0,
										18.75
									],
									[
										-18.75,
										0
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.015686275437,
								0.450980395079,
								0.917647063732,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								19,
								19
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 18,
		ty: 4,
		nm: "Bottom Ring",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.142
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.453
							],
							y: [
								0
							]
						},
						t: 90,
						s: [
							30
						]
					},
					{
						i: {
							x: [
								0.587
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.26
							],
							y: [
								0
							]
						},
						t: 121,
						s: [
							80
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 140,
						s: [
							30
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0
							]
						},
						t: 150,
						s: [
							30
						]
					},
					{
						t: 180,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 60,
						s: [
							669.494,
							889.183,
							0
						],
						to: [
							6.043,
							16.345,
							0
						],
						ti: [
							-6.043,
							-16.345,
							0
						]
					},
					{
						t: 140,
						s: [
							705.75,
							987.25,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					23,
					23,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0,
								0,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 60,
						s: [
							0,
							0,
							100
						]
					},
					{
						t: 100,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										6.204,
										0
									],
									[
										0,
										-6.204
									],
									[
										-6.203,
										0
									],
									[
										0,
										6.203
									]
								],
								o: [
									[
										-6.203,
										0
									],
									[
										0,
										6.203
									],
									[
										6.204,
										0
									],
									[
										0,
										-6.204
									]
								],
								v: [
									[
										0,
										-11.25
									],
									[
										-11.25,
										0
									],
									[
										0,
										11.25
									],
									[
										11.25,
										0
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 1,
						ty: "sh",
						ix: 2,
						ks: {
							a: 0,
							k: {
								i: [
									[
										12.407,
										0
									],
									[
										0,
										12.407
									],
									[
										-12.407,
										0
									],
									[
										0,
										-12.407
									]
								],
								o: [
									[
										-12.407,
										0
									],
									[
										0,
										-12.407
									],
									[
										12.407,
										0
									],
									[
										0,
										12.407
									]
								],
								v: [
									[
										0,
										22.5
									],
									[
										-22.5,
										0
									],
									[
										0,
										-22.5
									],
									[
										22.5,
										0
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 2",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "mm",
						mm: 1,
						nm: "Merge Paths 1",
						mn: "ADBE Vector Filter - Merge",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.219607844949,
								0.823529422283,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								22.75,
								22.75
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 4,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 19,
		ty: 4,
		nm: "Top Ring",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.142
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.453
							],
							y: [
								0
							]
						},
						t: 90,
						s: [
							50
						]
					},
					{
						i: {
							x: [
								0.587
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.26
							],
							y: [
								0
							]
						},
						t: 121,
						s: [
							70
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 140,
						s: [
							50
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0
							]
						},
						t: 150,
						s: [
							50
						]
					},
					{
						t: 180,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 60,
						s: [
							457.224,
							289.394,
							0
						],
						to: [
							-6.746,
							-25.711,
							0
						],
						ti: [
							6.746,
							25.711,
							0
						]
					},
					{
						t: 140,
						s: [
							416.75,
							135.125,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					30.5,
					30.5,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0,
								0,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 60,
						s: [
							0,
							0,
							100
						]
					},
					{
						t: 100,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										10.338,
										0
									],
									[
										0,
										-10.338
									],
									[
										-10.338,
										0
									],
									[
										0,
										10.338
									]
								],
								o: [
									[
										-10.338,
										0
									],
									[
										0,
										10.338
									],
									[
										10.338,
										0
									],
									[
										0,
										-10.338
									]
								],
								v: [
									[
										0,
										-18.75
									],
									[
										-18.75,
										0
									],
									[
										0,
										18.75
									],
									[
										18.75,
										0
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ind: 1,
						ty: "sh",
						ix: 2,
						ks: {
							a: 0,
							k: {
								i: [
									[
										16.542,
										0
									],
									[
										0,
										16.542
									],
									[
										-16.542,
										0
									],
									[
										0,
										-16.542
									]
								],
								o: [
									[
										-16.542,
										0
									],
									[
										0,
										-16.542
									],
									[
										16.542,
										0
									],
									[
										0,
										16.542
									]
								],
								v: [
									[
										0,
										30
									],
									[
										-30,
										0
									],
									[
										0,
										-30
									],
									[
										30,
										0
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 2",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "mm",
						mm: 1,
						nm: "Merge Paths 1",
						mn: "ADBE Vector Filter - Merge",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.219607844949,
								0.823529422283,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								30.25,
								30.25
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 4,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 20,
		ty: 4,
		nm: "Top Plus",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.142
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.453
							],
							y: [
								0
							]
						},
						t: 90,
						s: [
							30
						]
					},
					{
						i: {
							x: [
								0.587
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.26
							],
							y: [
								0
							]
						},
						t: 121,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 140,
						s: [
							30
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0
							]
						},
						t: 160,
						s: [
							30
						]
					},
					{
						t: 190,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 70,
						s: [
							-180
						]
					},
					{
						t: 160,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 70,
						s: [
							602.625,
							299.75,
							0
						],
						to: [
							4,
							-24.958,
							0
						],
						ti: [
							-4,
							24.958,
							0
						]
					},
					{
						t: 140,
						s: [
							626.625,
							150,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					19.5,
					19.5,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0,
								0,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 70,
						s: [
							0,
							0,
							100
						]
					},
					{
						t: 100,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										7.259,
										-17.691
									],
									[
										4.398,
										-2.967
									],
									[
										19.121,
										-0.104
									],
									[
										17.691,
										7.258
									],
									[
										2.966,
										4.394
									],
									[
										0.104,
										19.122
									],
									[
										-7.259,
										17.689
									],
									[
										-4.396,
										2.963
									],
									[
										-19.121,
										0.104
									],
									[
										-17.69,
										-7.258
									],
									[
										-2.965,
										-4.399
									],
									[
										-0.103,
										-19.122
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.015686275437,
								0.450980395079,
								0.917647063732,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								19.371,
								19.372
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 21,
		ty: 4,
		nm: "Bottom Left Plus",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.142
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.453
							],
							y: [
								0
							]
						},
						t: 90,
						s: [
							30
						]
					},
					{
						i: {
							x: [
								0.587
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.26
							],
							y: [
								0
							]
						},
						t: 121,
						s: [
							80
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 140,
						s: [
							30
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0
							]
						},
						t: 150,
						s: [
							30
						]
					},
					{
						t: 180,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 90,
						s: [
							-360
						]
					},
					{
						t: 150,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 90,
						s: [
							343.485,
							707.19,
							0
						],
						to: [
							-31.143,
							19.802,
							0
						],
						ti: [
							31.143,
							-19.802,
							0
						]
					},
					{
						t: 140,
						s: [
							156.625,
							826,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					19.5,
					19.5,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0,
								0,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 90,
						s: [
							0,
							0,
							100
						]
					},
					{
						t: 100,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										7.259,
										-17.691
									],
									[
										4.398,
										-2.967
									],
									[
										19.121,
										-0.104
									],
									[
										17.691,
										7.258
									],
									[
										2.966,
										4.394
									],
									[
										0.104,
										19.122
									],
									[
										-7.259,
										17.689
									],
									[
										-4.396,
										2.963
									],
									[
										-19.121,
										0.104
									],
									[
										-17.69,
										-7.258
									],
									[
										-2.965,
										-4.399
									],
									[
										-0.103,
										-19.122
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.219607844949,
								0.823529422283,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								19.371,
								19.372
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 22,
		ty: 4,
		nm: "Bottom Right Plus",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.142
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.453
							],
							y: [
								0
							]
						},
						t: 90,
						s: [
							50
						]
					},
					{
						i: {
							x: [
								0.587
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.26
							],
							y: [
								0
							]
						},
						t: 121,
						s: [
							80
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 140,
						s: [
							50
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0
							]
						},
						t: 160,
						s: [
							50
						]
					},
					{
						t: 190,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 60,
						s: [
							-360
						]
					},
					{
						t: 160,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 60,
						s: [
							784.157,
							702.348,
							0
						],
						to: [
							31.099,
							12.859,
							0
						],
						ti: [
							-31.099,
							-12.859,
							0
						]
					},
					{
						t: 140,
						s: [
							970.75,
							779.5,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					19.5,
					19.5,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0,
								0,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 60,
						s: [
							0,
							0,
							100
						]
					},
					{
						t: 100,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										7.259,
										-17.691
									],
									[
										4.398,
										-2.967
									],
									[
										19.121,
										-0.104
									],
									[
										17.691,
										7.258
									],
									[
										2.966,
										4.394
									],
									[
										0.104,
										19.122
									],
									[
										-7.259,
										17.689
									],
									[
										-4.396,
										2.963
									],
									[
										-19.121,
										0.104
									],
									[
										-17.69,
										-7.258
									],
									[
										-2.965,
										-4.399
									],
									[
										-0.103,
										-19.122
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.219607844949,
								0.823529422283,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								19.371,
								19.372
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 23,
		ty: 4,
		nm: "Bottom Star",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.142
							],
							y: [
								0.777
							]
						},
						o: {
							x: [
								0.453
							],
							y: [
								0
							]
						},
						t: 90,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.587
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.26
							],
							y: [
								4.152
							]
						},
						t: 121,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 140,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0
							]
						},
						t: 180,
						s: [
							100
						]
					},
					{
						t: 209,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0
							],
							y: [
								1.004
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 70,
						s: [
							360
						]
					},
					{
						t: 150,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 70,
						s: [
							482.263,
							679.201,
							0
						],
						to: [
							-24.294,
							34.883,
							0
						],
						ti: [
							24.294,
							-34.883,
							0
						]
					},
					{
						t: 140,
						s: [
							336.5,
							888.5,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					28.5,
					28.5,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0,
								0,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 70,
						s: [
							0,
							0,
							100
						]
					},
					{
						t: 100,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0.002,
										0.001
									],
									[
										0.005,
										0.005
									],
									[
										0.018,
										0.014
									],
									[
										0.332,
										-0.268
									],
									[
										18.129,
										12.982
									],
									[
										0.337,
										-0.214
									],
									[
										0.003,
										-2e-3
									],
									[
										0.021,
										-0.016
									],
									[
										0.005,
										-4e-3
									],
									[
										0.015,
										-0.014
									],
									[
										0.01,
										-0.01
									],
									[
										0.01,
										-0.012
									],
									[
										0.013,
										-0.017
									],
									[
										0,
										0
									],
									[
										0.014,
										-0.025
									],
									[
										-0.255,
										-0.299
									],
									[
										11.865,
										-17.613
									],
									[
										-0.279,
										-0.338
									],
									[
										-2e-3,
										-3e-3
									],
									[
										0,
										0
									],
									[
										-0.013,
										-0.011
									],
									[
										-0.011,
										-0.01
									],
									[
										-4e-3,
										-4e-3
									],
									[
										-0.354,
										0.287
									],
									[
										-18.128,
										-12.978
									],
									[
										-0.338,
										0.214
									],
									[
										-2e-3,
										0.003
									],
									[
										-0.021,
										0.017
									],
									[
										-5e-3,
										0.005
									],
									[
										-0.016,
										0.014
									],
									[
										-0.01,
										0.01
									],
									[
										-9e-3,
										0.011
									],
									[
										-0.012,
										0.018
									],
									[
										-5e-3,
										0.006
									],
									[
										-0.015,
										0.026
									],
									[
										0.253,
										0.298
									],
									[
										-11.859,
										17.62
									],
									[
										0.279,
										0.339
									],
									[
										0.002,
										0.002
									],
									[
										0.001,
										0
									],
									[
										0.012,
										0.013
									],
									[
										0.008,
										0.009
									]
								],
								o: [
									[
										-2e-3,
										-2e-3
									],
									[
										-6e-3,
										-6e-3
									],
									[
										-0.018,
										-0.016
									],
									[
										-0.336,
										-0.264
									],
									[
										-17.616,
										11.873
									],
									[
										-0.306,
										-0.257
									],
									[
										-2e-3,
										0.001
									],
									[
										-0.022,
										0.014
									],
									[
										-6e-3,
										0.005
									],
									[
										-0.017,
										0.014
									],
									[
										-0.01,
										0.01
									],
									[
										-0.011,
										0.01
									],
									[
										-0.014,
										0.015
									],
									[
										0,
										0
									],
									[
										-0.017,
										0.023
									],
									[
										-0.201,
										0.336
									],
									[
										12.973,
										18.125
									],
									[
										-0.281,
										0.338
									],
									[
										0.001,
										0.004
									],
									[
										0,
										0
									],
									[
										0.012,
										0.013
									],
									[
										0.01,
										0.011
									],
									[
										0.004,
										0.004
									],
									[
										0.334,
										0.311
									],
									[
										17.623,
										-11.866
									],
									[
										0.306,
										0.258
									],
									[
										0.002,
										-3e-3
									],
									[
										0.023,
										-0.015
									],
									[
										0.006,
										-5e-3
									],
									[
										0.017,
										-0.012
									],
									[
										0.01,
										-9e-3
									],
									[
										0.01,
										-0.011
									],
									[
										0.015,
										-0.016
									],
									[
										0.005,
										-5e-3
									],
									[
										0.016,
										-0.023
									],
									[
										0.201,
										-0.336
									],
									[
										-12.975,
										-18.126
									],
									[
										0.28,
										-0.338
									],
									[
										-2e-3,
										-2e-3
									],
									[
										-1e-3,
										0
									],
									[
										-0.011,
										-0.013
									],
									[
										-8e-3,
										-9e-3
									],
									[
										0,
										0
									]
								],
								v: [
									[
										27.847,
										-27.868
									],
									[
										27.842,
										-27.873
									],
									[
										27.824,
										-27.889
									],
									[
										27.77,
										-27.935
									],
									[
										26.628,
										-27.927
									],
									[
										-26.618,
										-27.916
									],
									[
										-27.697,
										-27.988
									],
									[
										-27.705,
										-27.983
									],
									[
										-27.77,
										-27.937
									],
									[
										-27.786,
										-27.924
									],
									[
										-27.834,
										-27.882
									],
									[
										-27.864,
										-27.852
									],
									[
										-27.895,
										-27.819
									],
									[
										-27.935,
										-27.77
									],
									[
										-27.948,
										-27.753
									],
									[
										-27.995,
										-27.681
									],
									[
										-27.905,
										-26.618
									],
									[
										-27.914,
										26.616
									],
									[
										-27.916,
										27.782
									],
									[
										-27.911,
										27.792
									],
									[
										-27.91,
										27.792
									],
									[
										-27.872,
										27.829
									],
									[
										-27.841,
										27.861
									],
									[
										-27.828,
										27.874
									],
									[
										-26.629,
										27.915
									],
									[
										26.616,
										27.902
									],
									[
										27.697,
										27.977
									],
									[
										27.704,
										27.968
									],
									[
										27.769,
										27.922
									],
									[
										27.786,
										27.908
									],
									[
										27.834,
										27.867
									],
									[
										27.864,
										27.837
									],
									[
										27.894,
										27.805
									],
									[
										27.934,
										27.755
									],
									[
										27.948,
										27.738
									],
									[
										27.995,
										27.666
									],
									[
										27.907,
										26.605
									],
									[
										27.914,
										-26.632
									],
									[
										27.916,
										-27.798
									],
									[
										27.911,
										-27.805
									],
									[
										27.909,
										-27.806
									],
									[
										27.874,
										-27.845
									],
									[
										27.849,
										-27.872
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.015686275437,
								0.450980395079,
								0.917647063732,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								28.446,
								28.452
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 24,
		ty: 4,
		nm: "Top Star",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.085
							],
							y: [
								0.783
							]
						},
						o: {
							x: [
								0.41
							],
							y: [
								0
							]
						},
						t: 70,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.616
							],
							y: [
								0.994
							]
						},
						o: {
							x: [
								0.286
							],
							y: [
								0.101
							]
						},
						t: 121,
						s: [
							80
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 140,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0
							]
						},
						t: 180,
						s: [
							100
						]
					},
					{
						t: 210,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0
							],
							y: [
								1.008
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 70,
						s: [
							-180
						]
					},
					{
						t: 160,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.375,
							y: 0
						},
						t: 70,
						s: [
							615.091,
							479.426,
							0
						],
						to: [
							33.11,
							-35.943,
							0
						],
						ti: [
							-33.11,
							35.943,
							0
						]
					},
					{
						t: 130,
						s: [
							813.75,
							263.766,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					37.5,
					39,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0,
								0,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.356,
								0.356,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 70,
						s: [
							0,
							0,
							100
						]
					},
					{
						t: 100,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0.003,
										0.002
									],
									[
										0.009,
										0.007
									],
									[
										0.025,
										0.02
									],
									[
										0.438,
										-0.366
									],
									[
										23.947,
										17.717
									],
									[
										0.445,
										-0.291
									],
									[
										0.003,
										-3e-3
									],
									[
										0.028,
										-0.023
									],
									[
										0.007,
										-6e-3
									],
									[
										0.021,
										-0.019
									],
									[
										0.013,
										-0.014
									],
									[
										0.013,
										-0.015
									],
									[
										0.018,
										-0.023
									],
									[
										0.006,
										-8e-3
									],
									[
										0.02,
										-0.033
									],
									[
										-0.335,
										-0.408
									],
									[
										15.673,
										-24.038
									],
									[
										-0.369,
										-0.463
									],
									[
										-3e-3,
										-4e-3
									],
									[
										0,
										0
									],
									[
										-0.016,
										-0.017
									],
									[
										-0.013,
										-0.014
									],
									[
										0,
										0
									],
									[
										-0.468,
										0.391
									],
									[
										-23.946,
										-17.715
									],
									[
										-0.447,
										0.292
									],
									[
										-3e-3,
										0.004
									],
									[
										-0.027,
										0.021
									],
									[
										-7e-3,
										0.007
									],
									[
										-0.02,
										0.02
									],
									[
										-0.013,
										0.014
									],
									[
										-0.012,
										0.015
									],
									[
										-0.017,
										0.023
									],
									[
										-6e-3,
										0.008
									],
									[
										-0.019,
										0.033
									],
									[
										0.335,
										0.407
									],
									[
										-15.665,
										24.049
									],
									[
										0.369,
										0.463
									],
									[
										0,
										0
									],
									[
										0,
										0.001
									],
									[
										0.017,
										0.017
									],
									[
										0.011,
										0.012
									]
								],
								o: [
									[
										-2e-3,
										-2e-3
									],
									[
										-8e-3,
										-8e-3
									],
									[
										-0.023,
										-0.022
									],
									[
										-0.443,
										-0.36
									],
									[
										-23.27,
										16.206
									],
									[
										-0.404,
										-0.35
									],
									[
										-3e-3,
										0.002
									],
									[
										-0.03,
										0.019
									],
									[
										-7e-3,
										0.006
									],
									[
										-0.022,
										0.018
									],
									[
										-0.014,
										0.014
									],
									[
										-0.014,
										0.015
									],
									[
										-0.018,
										0.021
									],
									[
										-5e-3,
										0.008
									],
									[
										-0.023,
										0.032
									],
									[
										-0.265,
										0.46
									],
									[
										17.137,
										24.737
									],
									[
										-0.37,
										0.461
									],
									[
										0.002,
										0.003
									],
									[
										0,
										0
									],
									[
										0.016,
										0.017
									],
									[
										0.014,
										0.015
									],
									[
										0,
										0
									],
									[
										0.441,
										0.423
									],
									[
										23.278,
										-16.197
									],
									[
										0.403,
										0.352
									],
									[
										0.003,
										-4e-3
									],
									[
										0.029,
										-0.02
									],
									[
										0.008,
										-7e-3
									],
									[
										0.022,
										-0.017
									],
									[
										0.014,
										-0.013
									],
									[
										0.014,
										-0.014
									],
									[
										0.019,
										-0.022
									],
									[
										0.005,
										-8e-3
									],
									[
										0.022,
										-0.031
									],
									[
										0.266,
										-0.46
									],
									[
										-17.139,
										-24.739
									],
									[
										0.37,
										-0.461
									],
									[
										0,
										0
									],
									[
										-1e-3,
										0
									],
									[
										-0.016,
										-0.018
									],
									[
										-0.011,
										-0.012
									],
									[
										0,
										0
									]
								],
								v: [
									[
										36.783,
										-38.037
									],
									[
										36.776,
										-38.043
									],
									[
										36.752,
										-38.064
									],
									[
										36.68,
										-38.127
									],
									[
										35.173,
										-38.116
									],
									[
										-35.16,
										-38.101
									],
									[
										-36.585,
										-38.2
									],
									[
										-36.595,
										-38.192
									],
									[
										-36.682,
										-38.129
									],
									[
										-36.703,
										-38.111
									],
									[
										-36.766,
										-38.056
									],
									[
										-36.806,
										-38.014
									],
									[
										-36.846,
										-37.97
									],
									[
										-36.9,
										-37.902
									],
									[
										-36.916,
										-37.879
									],
									[
										-36.979,
										-37.782
									],
									[
										-36.861,
										-36.329
									],
									[
										-36.872,
										36.327
									],
									[
										-36.874,
										37.92
									],
									[
										-36.867,
										37.931
									],
									[
										-36.866,
										37.931
									],
									[
										-36.817,
										37.983
									],
									[
										-36.776,
										38.025
									],
									[
										-36.758,
										38.045
									],
									[
										-35.174,
										38.1
									],
									[
										35.157,
										38.082
									],
									[
										36.585,
										38.184
									],
									[
										36.595,
										38.171
									],
									[
										36.68,
										38.11
									],
									[
										36.702,
										38.09
									],
									[
										36.765,
										38.033
									],
									[
										36.805,
										37.993
									],
									[
										36.845,
										37.949
									],
									[
										36.899,
										37.882
									],
									[
										36.916,
										37.858
									],
									[
										36.978,
										37.76
									],
									[
										36.862,
										36.311
									],
									[
										36.872,
										-36.348
									],
									[
										36.874,
										-37.941
									],
									[
										36.868,
										-37.949
									],
									[
										36.866,
										-37.952
									],
									[
										36.818,
										-38.004
									],
									[
										36.786,
										-38.041
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.219607844949,
								0.823529422283,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								37.494,
								38.742
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	}
];
const markers = [
];
const aniD1 = {
	v: v,
	meta: meta,
	fr: fr,
	ip: ip,
	op: op,
	w: w,
	h: h,
	nm: nm,
	ddd: ddd,
	assets: assets,
	layers: layers,
	markers: markers
};

export { assets, ddd, aniD1 as default, fr, h, ip, layers, markers, meta, nm, op, v, w };
